export default __webpack_public_path__ + "static/media/addNew.2d2b56ac.svg";